// WorldID App configuration
// App ID is a public client-side identifier (not a secret).
export const WORLDCOIN_APP_ID = (
  process.env.REACT_APP_WORLDCOIN_APP_ID || 'app_cf52901a511939a29bf6659af05aaa95'
) as `app_${string}`;

export const WORLDCOIN_ACTION = process.env.REACT_APP_WC_ACTION || 'verify-identity';

export const GUN_RELAY = process.env.REACT_APP_GUN_RELAY || 'https://www.joystance.com/gun';
